/**
 * The sources the public pages log under. The values are stored verbatim on the log rows
 * and matched exactly by the report endpoint, so writers and the filter share this list.
 */
export enum PublicLogSource {
  ProspectPage = 'public_prospect_page',
  RealtorPage = 'public_realtor_page'
}
